import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import ImageCarousel from '@homeaway/react-single-image-carousel';
import {SVGIcon} from '@homeaway/react-svg';

import {pushEdapEvent} from '../../../utils/edap';
import {selector} from '../../../utils/wdio-selectors';

const SVG_SERP_CHEVRON_LEFT__24 =
    '<svg data-id="SVG_SERP_CHEVRON_LEFT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" d="M16 23L5 12 16 1"></path></svg>';
const SVG_SERP_CHEVRON_RIGHT__24 =
    '<svg data-id="SVG_SERP_CHEVRON_RIGHT__24" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" d="M8 23l11-11L8 1"></path></svg>';

function sendToEdap(direction, actionlocation, hasEdapFastPathEvents) {
    const eventData = {
        actionlocation,
        eventcategory: 'photo-album-arrow-click',
        eventaction: `${direction}-arrow-clicked`,
    };
    pushEdapEvent('generic.event', eventData);

    if (hasEdapFastPathEvents) {
        pushEdapEvent('ux.cards_visible.adjusted', {
            action_location: actionlocation,
            event_action: `${direction}-arrow-clicked`,
            event_category: 'photo-album-arrow-click',
        });
    }
}

function getCarouselImages(props) {
    const {propertyName, imageCount, images} = props;
    return images
        .slice(0, imageCount)
        .map((src) => ({src, altText: propertyName}));
}

function renderButtons({setPrevRef, setNextRef}) {
    return [
        <button
            key="0"
            className="SingleImageCarousel__button SingleImageCarousel__button--left"
            data-wdio={selector.carouselPrev}
            ref={setPrevRef}
        >
            <span className="sr-only">{'Previous Image'}</span>
            <SVGIcon
                className="SingleImageCarousel__svg SingleImageCarousel__svg--left"
                markup={SVG_SERP_CHEVRON_LEFT__24}
            />
        </button>,
        <button
            key="1"
            className="SingleImageCarousel__button SingleImageCarousel__button--right"
            data-wdio={selector.carouselNext}
            ref={setNextRef}
        >
            <span className="sr-only">{'Next Image'}</span>
            <SVGIcon
                className="SingleImageCarousel__svg SingleImageCarousel__svg--right"
                markup={SVG_SERP_CHEVRON_RIGHT__24}
            />
        </button>,
    ];
}

export class ImageCardComponent extends PureComponent {
    constructor() {
        super();
        this.state = {
            currentIndex: 0,
        };
    }

    onImageNavigate = (currentIndex, direction) => {
        const {
            actionLocation = 'properties-module',
            hasEdapFastPathEvents,
        } = this.props;

        this.setState({currentIndex});
        sendToEdap(direction, actionLocation, hasEdapFastPathEvents);
    };

    onImageNavigateLeft = (index) => {
        this.onImageNavigate(index, 'left');
    };

    onImageNavigateRight = (index) => {
        this.onImageNavigate(index, 'right');
    };

    render() {
        const {onClick, listingUri, target} = this.props;
        const {currentIndex} = this.state;
        const images = getCarouselImages(this.props);

        return (
            <ImageCarousel
                key={Math.random()}
                images={images}
                onNextClick={this.onImageNavigateRight}
                onPrevClick={this.onImageNavigateLeft}
                index={currentIndex}
                tabIndex={-1}
                onClick={onClick}
                renderButtons={renderButtons}
                href={listingUri}
                target={target}
            />
        );
    }
}

export function mapStateToProps(state) {
    const {isMobile, isTablet} = state.config;
    const isDesktop = !(isMobile || isTablet);

    const imageCount = isDesktop ? 3 : 1;

    return {imageCount};
}

export const ImageCard = connect(mapStateToProps)(ImageCardComponent);

ImageCard.displayName = 'ImageCard';

export default ImageCard;
